import { render, staticRenderFns } from "./Boundary.vue?vue&type=template&id=54ae5f6b"
import script from "./Boundary.vue?vue&type=script&lang=js"
export * from "./Boundary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports